import { Record } from "immutable";
import { CollectionUtils } from "utilities/collection-utils";
import { RecordUtils } from "utilities/record-utils";
import { CreateBulkGroupUsersDto } from "../../interfaces/groups/create-bulk-group-users-dto";
import { GroupUserUploadResultRecord } from "./group-user-upload-result-record";

// -------------------------------------------------------------------------------------------------
// #region Default Values
// -------------------------------------------------------------------------------------------------

const defaultValues: CreateBulkGroupUsersDto = {
    groupUsers: undefined,
    groupId: undefined,
};

// #endregion Default Values

// -------------------------------------------------------------------------------------------------
// #region Record
// -------------------------------------------------------------------------------------------------

class CreateBulkGroupUsersDtoRecord
    extends Record(defaultValues)
    implements CreateBulkGroupUsersDto
{
    // -------------------------------------------------------------------------------------------------
    // #region Constructor
    // -------------------------------------------------------------------------------------------------

    constructor(params?: Partial<CreateBulkGroupUsersDto>) {
        params = params ?? Object.assign({}, defaultValues);

        if (CollectionUtils.hasValues(params.groupUsers)) {
            params.groupUsers = RecordUtils.ensureRecords(
                params.groupUsers,
                GroupUserUploadResultRecord
            );
        }

        super(params);
    }

    // #endregion Constructor

    // -------------------------------------------------------------------------------------------------
    // #region Public Methods
    // -------------------------------------------------------------------------------------------------

    /**
     * Given a set of values for CreateBulkGroupUsersDto properties, create a new CreateBulkGroupUsersDtoRecord object from this
     * instance, overwriting the properties in the values parameter with values provided.
     *
     * @param {Partial<CreateBulkGroupUsersDto>} values The values to overwrite on this instance.
     * @returns A CreateBulkGroupUsersDtoRecord with values from this instance and the values parameter.
     */
    public with(values: Partial<CreateBulkGroupUsersDto>): CreateBulkGroupUsersDtoRecord {
        return new CreateBulkGroupUsersDtoRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods
}

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { CreateBulkGroupUsersDtoRecord };

// #endregion Exports
